import { colorsPalettes } from "@similarweb/styles";

export const getCompareStripedCircleGradient = (stripeColor: string) => `
    linear-gradient(
        135deg,
        ${colorsPalettes.carbon[0]} 0%,
        ${colorsPalettes.carbon[0]} 20%,
        ${stripeColor} 21%,
        ${stripeColor} 31%,
        ${colorsPalettes.carbon[0]} 32%,
        ${colorsPalettes.carbon[0]} 45%,
        ${stripeColor} 46%,
        ${stripeColor} 56%,
        ${colorsPalettes.carbon[0]} 57%,
        ${colorsPalettes.carbon[0]} 70%,
        ${stripeColor} 71%,
        ${stripeColor} 81%,
        ${colorsPalettes.carbon[0]} 82%,
        ${colorsPalettes.carbon[0]} 100%
    );
`;